<template>
  <div class="container-fluid">
    <template v-for="(disc, discId) in possibleItems.list">
      <div class="row" v-bind:key="discId">
        <div class="col-9 finish-disc" @click="editDisc = discId">
          <template v-if="discId === 'all'">
            <h5>{{ $t("Menu.list.finishes.allDiscs") }}</h5>
            <p><br /></p>
          </template>
          <template v-else>
            <h5 v-if="isAlloyCombi === false">
              {{ $tc("Common.ringLayout." + ringLayout, parseInt(discId) + 1) }}
            </h5>
            <h5 v-else>{{ $t("Common.ringLayout.alloyCombi") }}</h5>
            <template v-for="(item, index) in disc">
              <p
                class="text-start"
                v-bind:key="index"
                v-if="item.match && editDisc !== discId"
                @click="editDisc = discId"
              >
                {{ item.text }}
              </p>
            </template>
          </template>
        </div>
        <div class="col-3 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            v-if="editDisc != discId || editDisc === false"
            @click="editDisc = discId"
            alt="edit"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            v-if="editDisc == discId && editDisc !== false"
            @click="editDisc = false"
            alt="close"
          />
        </div>
        <div class="col-12" v-if="editDisc === discId">
          <ul class="default-option-list finishes">
            <template v-for="(item, index) in colorList">
              <template v-if="index">
                <li
                  v-bind:key="index"
                  @click="changeItem(item.itemnumber, item.alerts)"
                  class="pointer"
                  :class="{ match: item.match }"
                >
                  <img
                    class="thumb"
                    @error="
                      $parent.setIconNotAvailable(
                        $refs[
                          'finish' +
                            index +
                            '_' +
                            item.finish +
                            '_' +
                            item.color
                        ]
                      )
                    "
                    :ref="
                      'finish' + index + '_' + item.finish + '_' + item.color
                    "
                    :src="
                      $parent.getFinishIcon(
                        item.finish,
                        item.color,
                        item.itemnumber,
                        false
                      )
                    "
                    :srcset="
                      $parent.getFinishIcon(
                        item.finish,
                        item.color,
                        item.itemnumber,
                        true
                      )
                    "
                    :alt="item.text"
                  />
                  <p>{{ item.text }}</p>
                </li>
              </template>
            </template>
            <li v-if="!allFinishes" @click="allFinishes = true">
              <img class="thumb" :src="appUrl + '/img/icons/next.svg'" />
              {{ $t("Menu.list.finishes.next") }} &gt;
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "VariationsFinishes",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      editDisc: "0",
      allFinishes: true,
      ringLayout: SetData.getters.getRingLayout,
      maxItems: 99,
    };
  },
  methods: {
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
  },
  updated() {
    if (this.possibleItems.list.length === 1) {
      this.editDisc = 0;
    }
  },
  computed: {
    isAlloyCombi() {
      return this.$parent.$parent.$parent["isCurrentItemAlloyCombi"](
        SetData.getters.getCurrentItemId
      );
    },
    colorList: function () {
      let list = {};

      if (typeof this.possibleItems.list[this.editDisc] == "object") {
        let counter = 0;

        for (let key in this.possibleItems.list[this.editDisc]) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list[this.editDisc],
              key
            )
          ) {
            if (this.allFinishes === true || counter < this.maxItems) {
              list[key] = this.possibleItems.list[this.editDisc][key];
              counter++;
            }
          }
        }
      }

      return list;
    },
  },
  watch: {
    editDisc: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.editDisc !== false) {
            let length = Object.keys(
              this.possibleItems.list[this.editDisc]
            ).length;
            this.allFinishes = length <= this.maxItems + 1;
          } else {
            this.allFinishes = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .finish-disc {
    cursor: pointer;
  }
}
</style>
